// Mirror of apps/api/src/modules/dropdowns/metadataSchemas.ts.
// Drives the per-category extra-field editor in the Dropdown Manager UI.
// Keep in sync with the server registry (server is authoritative for validation).

export type MetadataFieldSchema =
  | {
      type: "enum";
      values: readonly string[];
      required: boolean;
      label: string;
      help?: string;
      lockedOnSystem?: boolean;
    }
  | {
      type: "text";
      required: boolean;
      label: string;
      help?: string;
      lockedOnSystem?: boolean;
      maxLength?: number;
    };

export type MetadataSchema = Record<string, MetadataFieldSchema>;

export const METADATA_SCHEMAS: Record<string, MetadataSchema> = {
  company_type: {
    category: {
      type: "enum",
      values: ["OPERATIONAL", "EXTERNAL"] as const,
      required: true,
      label: "Category",
      help: "Locked discriminator: which side of the wall this type belongs to.",
      lockedOnSystem: true,
    },
    systemCode: {
      type: "text",
      required: false,
      label: "System Code",
      help: "Used by code to attach behavior — leave blank for purely descriptive types.",
      maxLength: 60,
      lockedOnSystem: true,
    },
  },
};

export function getMetadataSchema(category: string): MetadataSchema | null {
  return METADATA_SCHEMAS[category] ?? null;
}
